<template>
  <div class="form-group esma_form_group">
    <label v-if="showLabel" v-bind:for="fieldID"
    :class="{'col-xs-4':true, 'control-label':true, 'esma_form_label':true,'esma_error_field':showAsError}"
    >{{fieldLabel}} <span v-if="isRequired" class="is_required" aria-hidden="true">＊</span></label>
    <div :class="fieldClass"  style="padding:1px 0px 1px 7px;">
      <select  class="form-control select-box2"
      :style="fieldStyle"
      :disabled="isDisabled"  v-on:change="updateValue($event.target.value)"
      v-bind:id="fieldID"  v-bind:name="fieldID"  v-bind:value="fieldValue" >
        <option v-for="o in fieldOptions"   :selected="o.value==fieldValue" v-bind:data="o.value" v-bind:key="o.value" :value="o.value">{{o.label}}</option>
      </select>
    </div>
  </div>
</template>
<script>
import { bus } from "@/libs/bus";
import debug from 'debug'
var select2_debug = debug("__esma:select-box2")

export default {
   data() {
        return {
            local_options : [],
            local_refresh_sequecnce: 1,
            show_as_error:false,
            disabled_is_required:false,
            page_controller_disabled:false,
        }
  },

  computed: {
    pageControllerDisabled:{
      get(){
        return this.page_controller_disabled;
      },
      set(v){
        this.page_controller_disabled = v;
      }
    },
    disabledIsRequired:{
      get(){
        return this.disabled_is_required;
      },
      set(v){
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if(typeof local_val == "undefined"){
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        this.disabled_is_required = v;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
      }
    },
    isRequired(){
      return this.localRefreshSequecnce > 0 && this.disabledIsRequired == false && (this.$props.data.error_if_blank || false);
    },
    showAsError:{
      get(){
        return this.show_as_error;
      },
      set(v){
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce:{
      get(){
        return this.local_refresh_sequecnce;
      },
      set(v){
        this.local_refresh_sequecnce = v;
      }
    },
    stateCurrentRow(){
      if(typeof this.$props.data.state_current_row != "undefined"){
        return this.$props.data.state_current_row;
      }else{
        return "current_row";
      }
    },
    stateCurrentEditing(){
      if(typeof this.$props.data.state_current_editing != "undefined"){
        return this.$props.data.state_current_editing;
      }else{
        return "current_editing";
      }
    },
    stateIsEditingNew(){
      if(typeof this.$props.data.state_is_editing_new != "undefined"){
        return this.$props.data.state_is_editing_new;
      }else{
        return "is_editing_new";
      }
    },
    fieldStyle(){
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || ";color:black;";
      return  (this.$props.data.style || "") + store_style;
    },
    fieldTableName() {
        //select2_debug("fieldTableName")
      return this.$props.data.table_name
    },
    fieldOptions() {
        select2_debug("fieldOptions",this.$props.data.options)
      this.local_options = []
      this.$props.data.options.forEach((d)=>{
        this.local_options.push(d)
      })
      if(this.local_options.indexOf(this.fieldValue) <0){
        select2_debug("adding ",this.fieldValue)
        // this.local_options.unshift({value:this.fieldValue, label:this.fieldValue})
      }
      select2_debug("options",this.local_options)
      return this.local_options;
    },
    fieldLabel() {
      return  this.$props.data.label;
    },
    fieldValue() {
      var val = this.$store.state[this.stateCurrentRow][this.fieldID]
      if(typeof val == "undefined"){
          return false;
      }
      if(this.local_options.indexOf(val) <0 && val != null && val != ""){
          // this.local_options.unshift(val)
      }
      select2_debug("fieldValue d",val,this.$store.state[this.stateCurrentRow][this.fieldID], this.fieldID)
      if(this.$store.state[this.stateCurrentRow][this.fieldID] === 0){// Nessecary for user_type
       return 0;
      }
      return this.$store.state[this.stateCurrentRow][this.fieldID] || "";
    },
    fieldID() {
      return this.$props.data.id;
    },
    fieldClass(){
      if(this.getOption("hide_label",false)==true){
        return "col-xs-12"
      }else{
        return "col-xs-8"
      }
    },
    showLabel(){
        //select2_debug("showLabel")
      if(this.getOption("hide_label",false)==true){
        return false
      }else{
        return true
      }
    },
    isDisabled() {
      var ret =  null
      if(this.$store.state[this.stateIsEditingNew] == true){
        ret =  ( this.pageControllerDisabled ||  this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined"); //TODO, can also has another field to force it.
      }else{
        ret =(this.pageControllerDisabled ||  this.$props.data.disabled  ||  this.$props.read  || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined");
      }
      select2_debug("isDisabled",ret,this.$props.data.disabled ,  this.$props.read , this.$store.state[this.stateCurrentRow][this.fieldID] )
      return ret;
    }
  },
    methods: {
    updateValue(d) {
        //select2_debug("updateValue",d)
      if (typeof this.$props.data.global_emit != "undefined") {
        bus.$emit(this.$props.data.global_emit, d);
      }
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
      if(this.$props.data.emit_input == true){
        this.$emit("on_update",{field:this.fieldID,val:d});
      }
    },
    getOption(name,def){
        //select2_debug("getOption",name,def)
      if(typeof this.$props.option[name] == "undefined"){
        return def
      }
      return this.$props.option[name]
    }
  },
  mounted() {
    this.$props.data.ref_field = this;
    this.$props.data.on_field_messages = (vm,msg,cb) =>{
      if(msg && msg.msg_type == "error"){
        if(msg.show_as_error_mode == false && this.showAsError == false){
          return cb(false);
        }
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if(typeof local_val == "undefined"){
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        if(msg.show_as_error_mode && msg.only_if_enabled == true && this.isDisabled == true){
          this.showAsError = false;
          this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
          this.updateValue(local_val);
          this.localRefreshSequecnce++;
          return cb(false);
        }
        this.showAsError = msg.show_as_error_mode || false;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
        return cb(true);
      }
    }

    if(this.$props.data.page_controller){
      this.$props.data.page_controller_msg = (options) =>{
        switch (options.cmd) {
          case "enable":
            this.pageControllerDisabled = false;
            break;
          case "disable":
            this.pageControllerDisabled = true;
            break;
          default:
            break;
        }
      }
    }
  },
  props: ["data", "value",'option','read']
};
</script>
<style scoped>
.esma_error_field {
  color:red;
}
.is_required{
  color:red;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  background-color: #cccccc;

  padding: 0px 6px 0px 6px;
}
.form-control {
  color: black;
  height: 24px;

  padding: 0px 6px 0px 6px;
}
.form-control::selection {
  color: white;
  background: #575757;
}
</style>



// WEBPACK FOOTER //
// select-box2.vue?70443401